import { Link, Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '../auth/AuthContext'
import { Wordmark } from '../components/Wordmark'
import { useI18n } from '../i18n'
import styles from './Auth.module.css'
import { ProductPreview } from './ProductPreview'

export function AuthLayout() {
  const { status } = useAuth()
  const { t } = useI18n()
  const location = useLocation()
  const keepsSession = location.pathname === '/verify' || location.pathname === '/reset'
  if (status === 'signedIn' && !keepsSession) return <Navigate to="/" replace />
  return (
    <div className={styles.layout}>
      <aside className={styles.aside}>
        <Link to="/login" className={styles.brandLink} aria-label={t('app.name')}>
          <Wordmark size="lg" />
        </Link>
        <p className={styles.tagline}>{t('app.tagline')}</p>
        <div className={styles.stage}>
          <ProductPreview />
        </div>
      </aside>
      <main id="main" className={styles.main}>
        <div className={styles.card}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
